import {
	ClusterContextMenuResponse,
	MapLayerItemType,
	MarkerContextMenuResponse,
	VisibleMarkerKeysResponse
} from "@sureview/v2-mapping-saas";

export interface MapState {
	markerContextMenuResponse?: MarkerContextMenuResponse | null | undefined;
	clusterContextMenuResponse?: ClusterContextMenuResponse | null | undefined;
	visibleMarkerKeysResponse?: VisibleMarkerKeysResponse | null | undefined;
	closeInfoWindow?: boolean | undefined;
	plotItem?: PlotItem | null | undefined;
}

export interface PlotItem {
	type: MapLayerItemType;
	objectId?: number | null;
}

export enum MapLayerItemCustomType {
	None = 0,
	SVG = 1,
	FontAwesome = 2,
}
